import React, { Component } from 'react';
// import { Route, Redirect } from 'react-router-dom';

import Personalizacion from './paraPersonalizar/personalizar.js';
import Colores from './paraColores/colores.js';
import VistaPrevia from './paraVistaPrevia/vistaPrevia.js';

class HomeParame extends Component {

    constructor(props){
        super(props);
        this.state = {
            datos:{
                tipoColor: '',
                color: ''
            }
        }
    }

    recibirColores = (tipoColor, color) => {
        this.setState(()=>({
            datos:{
                tipoColor,
                color
            }
        })); 
    }
    
    render(){
        return(
            <div>
                <Personalizacion />
                <Colores enviarColores={this.recibirColores}/>
                <VistaPrevia coloresNuevos={this.state.datos}/>
            </div>
        );
    }
}

export default HomeParame;